import { WIDGET_TRACKING } from './index';

export const STATSIG_CLIENT_KEY =
    'client-Vp3Oe1HevIDVQ1ZmwKjt0AGx6HK1osdC2x4we07JVsU';

export const STATSIG_OVERRIDE_PARAM = 'overrideStatsig';

export const STATSIG_LOGIN_INTERSTITIAL_EXPERIMENT_KEY =
    'login_as_interstitial_step_in_checkout';
export const STATSIG_INTERSTITIAL_LOGIN_PARAM = 'has_interstitial_step';

export const STATSIG_EVENT_NAMES = {
    LOGIN_INTERSTITIAL_LOAD: 'LoginInterstitialLoad',
    LOGIN_SUCCESS_ONE_STEP: 'LoginSuccessOneStep',
    CHECKOUT_LOAD: 'CheckoutLoad',
    COMPLETE_CHECKOUT_CLICK:
        WIDGET_TRACKING.RF_ORDER_SUBMITTED_WITHOUT_ERRORS.action,
    ORDER_SUCCESS_LOAD: 'OrderSuccessLoad',
    PAYMENT_SELECTION: WIDGET_TRACKING.RF_PAYMENT_METHOD_SELECT.action,
};
